<template>
    <div class="table-content">
        <el-form :model="form" ref="queryForm" :inline="true">
            <el-form-item>
                <el-select v-model="value" :popper-append-to-body="false" size="small" filterable collapse-tags placeholder="请选择类别">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        <span class="check" />
                        <span style="margin-left: 0.08rem;">{{ item.label }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker
                    style="height: 2rem;"
                    v-model="timeValue"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button class="refresh" size="mini" @click="firstSearch()">刷新<i class="el-icon-refresh-right"></i></el-button>
                <el-button class="search" size="mini" @click="firstSearch()">搜索</el-button>
                <el-button class="deltale" size="mini" @click="deltale()">清除</el-button>
                <el-button class="doexcel" size="mini" @click="doexcel()">导出</el-button>
            </el-form-item>
        </el-form>
        
        <el-table class="loadingPrivate" max-height="500" :data="tableData" style="width: 100%,font-size:0.5rem,margin-bottom:1rem">
            <el-table-column prop="id" label="序号ID" width="150"> </el-table-column>
            <el-table-column prop="realName" label="真实姓名" width="150"> </el-table-column>
            <el-table-column prop="phone" label="电话号码" width="150"> </el-table-column>
            <el-table-column prop="tradeAmount" label="交易金蟾豆数" width="150"> </el-table-column>
            <el-table-column prop="tradeStatus" label="交易状态" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.tradeStatus=='0'">提交中</span>
                    <span v-if="scope.row.tradeStatus=='1'">成功</span>
                    <span v-if="scope.row.tradeStatus=='2'">失败</span>
                </template>
            </el-table-column>
            <el-table-column prop="orderBody" label="订单类型" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.orderBody=='2'">云创</span>
                    <span v-if="scope.row.orderBody=='3'">金保通</span>
                </template>
            </el-table-column>
            <el-table-column prop="predictAmount" label="应发金额(分)" width="100"></el-table-column>
            <el-table-column prop="actualAmount" label="实发金额(分)" width="100"></el-table-column>
            <el-table-column prop="thirdOrderNo" label="三方订单号" width="250"></el-table-column>
            <el-table-column prop="tradeOrderNo" label="交易订单号" width="250"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200">
                <template slot-scope="scope">
                    <span >{{dataFormat(scope.row.createTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="endTime" label="完成时间" width="200">
                <template slot-scope="scope">
                    <span >{{dataFormat(scope.row.endTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="primary" size="mini">详情</el-button>
            </template>
            </el-table-column>
        </el-table>
        <div class="pagination" v-if="isPage">
            <el-pagination @size-change="handleSizeChange" @current-change="firstSearch"
            :current-page.sync="pageNumber" :page-size="15" layout=" prev, pager, next" :total="totalCount">
            </el-pagination>
            <div class="pagNum">共{{pagNum}}页 （共{{totalCount}}条）</div>
        </div>

    <!-- 详细弹窗 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="40%" >
        <div>
            <div style="font-size: 16px;">应发金额(分):</div>
            <div style="font-size: 14px;margin-top: 5px;">{{orderDetails.predictAmount}}</div>
        </div>
        <div style="margin-top: 10px;">
            <div style="font-size: 16px;">个人附加费(分):</div>
            <div style="font-size: 14px;margin-top: 5px;">{{orderDetails.additionalCharge}}</div>
        </div>
        <div style="margin-top: 10px;">
            <div style="font-size: 16px;">个人承担个税(分):</div>
            <div style="font-size: 14px;margin-top: 5px;">{{orderDetails.taxFee}}</div>
        </div>
        <div style="margin-top: 10px;">
            <div style="font-size: 16px;">个人服务费汇总(个人个税+个人附加费)(分):</div>
            <div style="font-size: 14px;margin-top: 5px;">{{orderDetails.personServiceFee}}</div>
        </div>
        <div style="margin-top: 10px;">
            <div style="font-size: 16px;">实发金额(分):</div>
            <div style="font-size: 14px;margin-top: 5px;">{{orderDetails.actualAmount}}</div>
        </div>
    </el-dialog>
    </div>
  </template>
  <script>
    import {
      Loading
    } from 'element-ui';
    export default {
      name: "message2",
      data() {
        return {
          tableData: [],
          paginations: {
            pageIndex: 1, // 当前位于哪页
            pageSize: 15, // 1页显示多少条
            pageSizes: [5, 10, 15, 20], //每页显示多少条
            layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
          },
          options: [{
            value: '2',
            label: '云创'
          }, {
            value: '3',
            label: '金保通'
          }],
          value: '',
          timeValue:[],
          isPage: true,
          token: "",
          pagNum: "", //总页数
          pageNumber: 1, //页码数
          pageSize: 15, //每页条数
          totalCount: 0, //总条数
          loading: "",
          // 订单显示隐藏
          dialogVisible:false,
          // 订单详情信息
          orderDetails:{},
          form:{

          }
        }
      },
      props: {},
      created() {
        this.token = sessionStorage.getItem('token');
        this.firstSearch(); //首次进入页面加载所有数据
      },
      mounted() {},
      methods: {
        //条数转页数
        pagNumS() {
            let pages = Math.ceil(this.totalCount / 15)
            this.pagNum = pages;
        },
        // 每页多少条切换 pageSize
        handleSizeChange(page_size) {
  
        },
    
        /**
         * 时间格式化
         */
        dataFormat(str){
            if(str == ''||str == undefined||str == null){
                return '';
            }
            let dt = new Date(str);
            let y = dt.getFullYear();
            let m = dt.getMonth() + 1;
            let d = dt.getDate();
            let hour = dt.getHours();
            let minute = dt.getMinutes();
            let second = dt.getSeconds();
            return `${y}-${m}-${d} ${hour}:${minute}:${second}`;
        },

        //首次进入加载数据
        firstSearch() {
            let time = this.timeValue;
            let startTime = '';
            let endTime = '';
            let params = {};
            if(time != [] && time !=null && time != undefined){
                startTime = time[0];
                endTime = time[1];

                params = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    token: this.token,
                    orderBody:this.value,
                    startTime:startTime,
                    endTime:endTime
                };
            }else{
                params = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    token: this.token,
                    orderBody:this.value
                };
            }
            
            let _this = this;
            let url = '/ft-oms/jkos/order/orderList.action'
            this.$http.post(url, params).then(res => {
                if (res.data.code == "200") {
                this.tableData = res.data.data.list;
                this.totalCount = res.data.data.total;
                this.pagNumS();
                this.isPage = true
                } else if (res.data.code == "99999") {
                if (res.data.data.code == '88886') {
                    this.$router.push({
                    path: "/login"
                    })
                } else {
                    this.tableData = [];
                    this.isPage = false
                }
                } else {
                this.tableData = [];
                this.isPage = false
                }
            });
        },
        //清除
        deltale() {
          this.value = '';
          this.timeValue = [];
        },
        //详情
        handleClick(row) {
            let params = {
                token: this.token,
                outMemberType:row.orderBody,
                outerOrderNo:row.tradeOrderNo,
            };
            let url = '/ft-oms/jkos/order/getBpotopTrade.action'
            this.$http.post(url, params).then(res => {
                if (res.data.code == "200") {
                    if(res.data.data=={}||res.data.data==undefined||res.data.data==null){
                        this.$message.error('未查询到订单信息');
                    }else{
                        this.orderDetails = res.data.data;
                        this.dialogVisible = true;
                    }
                } else if (res.data.code == "99999") {
                    if (res.data.data.code == '88886') {
                        this.$router.push({
                            path: "/login"
                        })
                    } else {
                        this.$message.error('未查询到订单信息');
                        this.isPage = false
                    }
                } else {
                    this.$message.error('未查询到订单信息');
                    this.isPage = false
                }
            });
        },

        /**
         * 导出
         */
        doexcel(){
            let time = this.timeValue;
            let startTime = '';
            let endTime = '';
            if(time != []){
                startTime = time[0];
                endTime = time[1];
            }
            let params = {
                token: this.token,
                orderBody:this.value,
                startTime:startTime,
                endTime:endTime
            };
            let url = '/ft-oms/jkos/order/isExporOrder.action'
            this.$http.post(url, params, {
                responseType: 'blob'
            }).then(res => {
                if(res.data.code=="99999"){
                    if(res.data.data.code=='88886'){
                        this.$router.push({
                            path:"/login"
                        })
                    }
                } else{
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    }); // res就是接口返回的文件流了
                    let objectUrl = URL.createObjectURL(blob);
                    window.location.href = objectUrl;
                }
            });
        }
      }
    }
  
  </script>
<style lang="scss">
.el-input__inner{
    .el-input__icon{
        line-height: 19px;
    }
    .el-range-separator{
        line-height: 19px;
    }
}
</style>
  <style scoped>
    body {
      margin: 0;
    }
  
    .pagination {
      /* margin-bottom: 1.2rem; */
      margin-top: 1.2rem;
      display: flex;
      justify-content: center;
      height: 1.8rem;
      font-size: 0.9rem;
      line-height: 1.8rem;
      /* width: 55%; */
    }
  
    .header {
      height: 3rem;
      display: flex;
      justify-content: space-between;
    }
  
    .filiale,
    .input {
      margin-right: 0.5rem;
    }
  
    .startDate,
    .endDate {
      margin-right: 0.5rem;
    }
  
    .search {
      border: 1px solid #FF9D47;
      border-radius: 0.2rem;
      /* height: 1.7rem;
        line-height: 1.7rem;
        width: 2.8rem; */
      text-align: center;
      font-size: 0.6rem;
      color: #FF9D47;
      /* margin-right: 0.6rem; */
    }
  
    .deltale {
      border: 1px solid #7A7A7A;
      border-radius: 0.2rem;
      /* height: 1.7rem;
        line-height: 1.7rem;
        width: 2.8rem; */
      text-align: center;
      font-size: 0.6rem;
      color: #7A7A7A;
      /* margin-right: 0.6rem; */
    }
  
    .doexcel {
      border: 1px solid #FF9D47;
      border-radius: 0.2rem;
      /* height: 1.7rem;
        line-height: 1.7rem;
        width: 2.8rem; */
      text-align: center;
      font-size: 0.6rem;
      color: #ffffff;
      background: #FF9D47;
    }
  
    .upload {
      border: 1px solid #FF9D47;
      border-radius: 0.2rem;
      text-align: center;
      font-size: 0.6rem;
      color: #ffffff;
      background: #FF9D47;
    }
  
    .pagNum {
      margin-left: 1.2rem;
      margin-top: 0.2rem;
    }
  
    .checkboxImg {
      width: 4.8rem;
      height: 1.2rem;
      border: 1px solid #999999;
      background: url("../../../../static/img/sousuo-2.png") no-repeat center right;
    }
  
    .checkboxDiv {
      width: 4.8rem;
      display: none;
      border: 1px solid #999999;
      border-top: none;
    }
  
    .headerLeft {
      display: flex;
    }
  
    .fun {
      display: flex;
      /* margin-top: 1rem; */
      margin-bottom: 1rem;
      float: right;
    }
  
    .input {
      display: flex;
      border: 1px solid #dedede;
      width: 9rem;
      height: 1.8rem;
      line-height: 1.8rem;
      border-radius: 0.25rem;
      color: #bfcbd9;
    }
  
    .input input {
      flex: 9;
      border: 0;
      font-size: 0.8rem;
      width: 5rem;
      outline: none;
    }
  
    .input img {
      width: 50%;
      height: 50%;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      flex: 1;
      margin-top: 0.4rem;
    }
  
  
    /*修改input框默认文本样式*/
    input::-webkit-input-placeholder {
      /* placeholder颜色 */
      color: #C1C1C1;
      /* placeholder字体大小 */
      /* font-size: 12px; */
    }
  
    .el-input__inner {
      height: 1.8rem;
      font-size: 0.72rem;
    }
  
    /*修改日期框样式*/
    .startDate>>>.el-date-editor {
      width: 12rem;
    }
  
    .startDate>>>.el-input__inner:focus {
      border-color: #FF9D47;
    }
  
    .endDate>>>.el-date-editor {
      width: 12rem;
    }
  
    .endDate>>>.el-input__inner:focus {
      border-color: #FF9D47;
    }
  
    /*修改下拉框样式*/
    .filiale>>>.el-input__inner {
      width: 10rem;
    }
  
    /* .el-select-dropdown__wrap {
        background: #b5879a !important;
      } */
    .filiale>>>.el-select .el-input.is-focus .el-input__inner {
      border-color: #FF9D47;
    }
  
    .filiale>>>.el-select .el-input__inner:focus {
      border-color: #FF9D47;
  
    }
  
    .el-select-dropdown__item.selected {
      color: #FF9D47;
    }
  
    .el-select-dropdown__item.hover {
      background-color: #ffffff;
    }
  
    .filiale>>>.el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: #FAF0E7;
      color: #FF9D47;
    }
  
    /*修改分页样式*/
    .pagination>>>.el-pager li.active {
      color: #FF9D47;
    }
  
    .pagination>>>.el-pager li:hover {
      color: #FF9D47;
    }
  
    .pagination>>>.el-icon-arrow-left:hover {
      color: #FF9D47;
    }
  
    .pagination>>>.el-icon-arrow-right:hover {
      color: #FF9D47;
    }
  
    .pagination>>>.el-icon-arrow-left.active {
      color: #FF9D47;
    }
  
    .pagination>>>.el-icon-arrow-right.active {
      color: #FF9D47;
    }
  
    .el-icon-arrow-left:hover {
      color: #FF9D47;
    }
  
    .el-icon-arrow-right:hover {
      color: #FF9D47;
    }
  
    .el-icon-arrow-left.active {
      color: #FF9D47;
    }
  
    .el-icon-arrow-right.active {
      color: #FF9D47;
    }
  
    .pagination>>>.el-pagination .btn-next:hover {
      color: #FF9D47;
    }
  
    .pagination>>>.el-pagination .btn-prev:hover {
      color: #FF9D47;
    }
  
    /*按钮样式*/
    .doexcel>>>.el-button--default .el-button--mini:hover {
      background-color: #FF9D47 !important;
      color: #ffffff;
      border-color: #FF9D47;
    }
  
    .upload>>>.el-button--default .el-button--mini:hover {
      background-color: #FF9D47 !important;
      color: #ffffff;
      border-color: #FF9D47;
    }
  
    .search>>>.el-button--default .el-button--mini:hover {
      background-color: #ffffff !important;
      color: #FF9D47;
      border-color: #FF9D47;
    }
  
    .deltale>>>.el-button--default .el-button--mini:hover {
      background-color: #ffffff !important;
      color: #000;
      border-color: #000;
    }
  
    /*修改table样式*/
    .table-content>>>.el-table thead.is-group th {
      background-color: #ffffff;
    }
  
    .table-content>>>.el-table thead.is-group .is-leaf {
      background-color: #ffffff;
    }
  
    .table-content>>>.el-table thead.is-group th:first-child {
      /* color: salmon; */
      background: #ffaec9;
    }
  
    .table-content>>>.el-table thead.is-group th:nth-child(2) {
      background: #ffc90e;
    }
  
    .table-content>>>.el-table thead.is-group th:nth-child(3) {
      background: #efe4b0;
    }
  
    .table-content>>>.el-table thead.is-group th:nth-child(4) {
      background: #b5e61d;
    }
  
    .table-content>>>.el-table thead.is-group .is-leaf:nth-child(1) {
      color: #909399;
      background-color: #ffffff;
    }
  
    .table-content>>>.el-table thead.is-group .is-leaf:nth-child(2) {
      color: #909399;
      background-color: #ffffff;
    }
  
    .table-content>>>.el-table thead.is-group .is-leaf:nth-child(3) {
      color: #909399;
      background-color: #ffffff;
    }
  
    .table-content>>>.el-table thead.is-group .is-leaf:nth-child(4) {
      color: #909399;
      background-color: #ffffff;
    }
  
    .table-content>>>.el-table .cell {
      text-align: center;
    }
  
    /* .table-content>>>.el-table .staff{
        background: red;
        color: royalblue;
      } */
    /* .table-content>>>.el-table_29_column_320{
        text-align: center;
        background: chartreuse;
      }
      .table-content>>>.el-table_29_column_325{
        text-align: center;
        background: red;
      } */
    .filiale>>>.el-select-dropdown__wrap {
      max-height: 295px;
    }
  
  </style>
  


// WEBPACK FOOTER //
// message2.vue?739115bc